import { render, staticRenderFns } from "./Supporters.vue?vue&type=template&id=3dd15f17&scoped=true&"
import script from "./Supporters.vue?vue&type=script&lang=js&"
export * from "./Supporters.vue?vue&type=script&lang=js&"
import style0 from "./Supporters.vue?vue&type=style&index=0&id=3dd15f17&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd15f17",
  null
  
)

export default component.exports